<template>
  <!--包件详细信息-->
  <div>
    <el-dialog
      :title="title"
      width="1000px"
      :visible.sync="visible"
      :before-close="cancelDialog"
      @close="cancelDialog"
      class="dialog-zindex dialog-sourcingflow-zindex"
    >
      <div class="dic-group-table-mod02" style="padding-top: 10px;">
        <div class="dic-group-table-title">
          <span class="dic-group-table-title-label">
            <!--基本信息-->
            {{ $t("page.biddinghall.basicInformation") }}
          </span>
        </div>

        <div class="dic-group-table-main">
          <el-form
            :model="packageData"
            class="demo-form-inline"
            label-width="130px"
          >
            <el-row>
              <el-col :span="24">
                <!--                包件名称-->
                <el-form-item
                  :label="`${$t('page.biddinghall.packageName')}：`"
                >
                  <span class="ellipsis-3">
                    {{ packageData.packName }}
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <!--                起拍价-->
                <el-form-item :label="`${$t('page.biddinghall.startPrice')}：`">
                  <div>{{ packageData.startMoney | bigNumberFormat(2) }}元</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!--包件说明：-->
              <el-col :span="24">
                <el-form-item
                  :label="`${$t('page.biddinghall.PackageDescription')}：`"
                >
                  <span class="ellipsis-3" :title="packageData.packRequire">
                    {{ packageData.packRequire }}
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="dic-group-table-mod02" style="padding-bottom: 20px;">
        <div class="dic-group-table-title">
          <span class="dic-group-table-title-label">
            <!--包件明细-->
            {{ $t("page.biddinghall.packageDetail") }}
          </span>
        </div>
        <div class="dic-group-table-main">
          <el-table
            class="dic-sub-table-style01"
            :data="packageData.materialDetailList"
            border
          >
            <el-table-column
              type="index"
              width="50"
              :label="$t('page.content.No')"
              align="center"
            >
              <template #default="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item2, index2) in materialColums"
              :key="index2"
              :label="item2.label"
              :prop="item2.prop"
              :width="item2.width"
              :min-width="item2.minWidth"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <template v-if="item2.slot === 'purchaseNum'">
                  {{ (scope.row[item2.prop] - 0).toFixed(3) }}
                </template>
                <template v-else>
                  {{ scope.row[item2.prop] || "" }}
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer">
        <el-button size="mini" type="default-mini" @click="cancelDialog">
          <!--关闭-->
          {{ $t("page.content.close") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "dialogPackageDetail",
  props: {
    title: {
      type: String,
      default: "包件明细"
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    packageData: {
      type: Object,
      default() {
        return {
          packName: "", //包件名称
          startMoney: "", //起拍价
          minimumDrop: "", //最小降幅
          packRequire: "", //包件说明
          materialDetailList: [
            //包件明细
          ]
        };
      }
    }
  },
  data() {
    return {
      visible: false,
      materialColums: [
        //设备物资名称
        {
          prop: "matName",
          label: this.$t("page.biddinghall.matName"),
          minWidth: 250
        },
        //设备物资说明
        {
          prop: "matDesc",
          label: this.$t("page.biddinghall.matDesc"),
          minWidth: 120
        },
        //数量
        {
          prop: "convNum",
          label: this.$t("page.biddinghall.purchaseNum"),
          width: 180,
          slot: "purchaseNum"
        },
        //计量单位
        {
          prop: "convMeasureUnitName",
          label: this.$t("page.biddinghall.measureUnitName"),
          width: 150
        }
      ]
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.visible = true;
      }
    }
  },
  mounted() {},
  methods: {
    // 关闭弹框
    cancelDialog() {
      this.$emit("update:dialogVisible", false);
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
.ellipsis-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
